import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as actions from './redux/actions';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import { CSVLink } from "react-csv";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
});

 class DownloadCsv extends Component {
  static propTypes = {

  };
  constructor(props) {
    super(props)
  
    this.downloadData=this.downloadData.bind(this)

    this.state = {
       headers:[],
       data:[], 
       tableName:"", 
       tableData:{}, 
       disabled:false
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps)
  {
    if(nextProps.tableData!==undefined &&nextProps.tableData.headers!==undefined && nextProps.tableData.headers.length>0){      
      this.setState({
        tableData:nextProps.tableData
      })
    }
  }

  downloadData=()=>
  {
    // the first thing is check the type range.
    this.props.actions.resetCsvData()
    if(!this.state.disabled && this.state.tableData.type<=5)
    {
      this.props.actions.costProcessingCsv(this.state.tableData)
      this.setState({
        disabled:true
      })
    }else if(!this.state.disabled){
      this.setState({
        data:this.state.tableData.data,
        headers:this.state.tableData.headers,
        disabled:true
      })
    }
    setTimeout(() => {
      this.setState({
        disabled:false
      })
      this.CsvLink.link.click()
    }, 2000);
    
  }
  render() {
    const { classes } = this.props;
    return (
      <div style={{display: this.props.ocultar ? 'none' : 'inerit' }}>
        {this.props.visible?
          <Grid item sm={9}>
            <CSVLink
            data={this.props.common.csvTableData===undefined ||this.props.common.csvTableData===null? this.state.data : this.props.common.csvTableData.data} 
            headers={this.props.common.csvTableData===undefined||this.props.common.csvTableData===null? this.state.headers : this.props.common.csvTableData.headers} 
            filename={localStorage.getItem("projectName")+'-'+this.state.tableData.tableName+".csv"}
            target="_blank" 
            ref={(r) => this.CsvLink = r} />
            <Button
              style={{marginTop:"35px",align:"rigth"}}
              variant="contained"
              color="primary"
              size="small"
              className={classes.button}
              startIcon={<SaveIcon />}
              onClick={this.downloadData}
              disabled={this.state.disabled}
            >
              CSV
            </Button>
          </Grid>
        :
        ""}
    </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(withStyles(styles)(DownloadCsv));



// WEBPACK FOOTER //
// ./src/features/common/DownloadCsv.js